import * as React from "react";
import { graphql } from "gatsby";
import { Seo } from "../components/seo";
import { getImage } from "gatsby-plugin-image";
import Layout from "../templates/siteLayout";
import { TemplateArticle } from "../templates/templateArticle";
import {
  IsArticleSeries,
  SeriesSeoTitle,
} from "../components/seriesNavigation";

export default function RenderPost(props) {
  const post = props?.data?.markdownRemark;
  return (
    <Layout>
      <TemplateArticle post={post} series={props?.data?.series} />
    </Layout>
  );
}

export const postQuery = graphql`
  query GetPostById($id: String!, $series: String!) {
    markdownRemark(id: { eq: $id }) {
      fields {
        permalink
      }
      frontmatter {
        layout
        class
        date(formatString: "MMM Do, YYYY")
        dateTime: date(formatString: "YYYY-MM-DD")
        last_modified_at(formatString: "MMMM DD, YYYY")
        modifiedDate: last_modified_at(formatString: "YYYY-MM-DD")
        description
        title
        seo_title
        tags
        background_position
        background_image
        author {
          name
        }
        series {
          name
          part
        }
        image {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              width: 1920
              tracedSVGOptions: { color: "#9c1e30" }
              placeholder: BLURRED
              layout: CONSTRAINED
            )
          }
        }
        transcribed_by
        featuring {
          name
          url
        }
        supplies {
          name
          url
        }
      }
      headings(depth: h2) {
        id
        value
      }
      timeToRead
      tableOfContents
      htmlAst
    }
    series: allMarkdownRemark(
      filter: {
        fields: { sourceName: { eq: "posts" } }
        frontmatter: { series: { name: { eq: $series } } }
      }
      sort: { frontmatter: { series: { part: ASC } } }
    ) {
      nodes {
        fields {
          permalink
        }
        frontmatter {
          title
          series_order
          series {
            name
            part
          }
        }
      }
    }
  }
`;

export const Head = ({ data }) => {
  const { markdownRemark: post, series } = data;

  const isSeries = IsArticleSeries({ series });

  const basicTitle = post.frontmatter.seo_title
    ? post.frontmatter.seo_title
    : post.frontmatter.title;

  const seriesTitle = isSeries ? SeriesSeoTitle({ post, series }) : basicTitle;

  const type = "Article";
  return (
    <>
      <Seo
        title={isSeries ? seriesTitle : basicTitle}
        description={post.frontmatter.description}
        image={
          post.frontmatter.image ? getImage(post.frontmatter.image) : false
        }
        type={type}
        attributes={{
          author: post.frontmatter.author?.name,
          published: post.frontmatter.dateTime,
          modified: post.frontmatter.modifiedDate,
          review: post.frontmatter.review,
        }}
      ></Seo>
    </>
  );
};
